import React from 'react';

import CloseIcon from '@atlaskit/icon/core/cross-circle';
import SearchIcon from '@atlaskit/icon/core/search';
import { components } from '@atlaskit/react-select/components';
import type { DropdownIndicatorProps, InputActionMeta } from '@atlaskit/select/types';

import { type SingleOption } from '../../../../common/types';
import {
	CloseIconWrapper,
	DisplayWrapper,
	DropdownIndicatorWrapper,
} from '../../../../common/ui/picker/styled';

// EM-2028 TODO: We are rendering both icons and hiding them via CSS display rule because
// the Popup component's ref is not correctly updated when this react-select component
// re-renders. i.e. it does not  update the refs when one of these components re-renders.
export const DropdownIndicator = (
	props: DropdownIndicatorProps<SingleOption, boolean>,
): React.JSX.Element => (
	<components.DropdownIndicator {...props}>
		<DropdownIndicatorWrapper>
			<DisplayWrapper displayFlag={!!props.selectProps.inputValue}>
				<CloseIconWrapper
					onClick={(event) => {
						event.preventDefault();
						props.selectProps.onInputChange?.('', {
							action: 'input-change',
							prevInputValue: props.selectProps.inputValue,
						} as InputActionMeta);
					}}
				>
					<CloseIcon color="currentColor" label="" size="small" />
				</CloseIconWrapper>
			</DisplayWrapper>
			<DisplayWrapper displayFlag={!props.selectProps.inputValue}>
				<SearchIcon color="currentColor" label="" />
			</DisplayWrapper>
		</DropdownIndicatorWrapper>
	</components.DropdownIndicator>
);
